export default [
  { label: 'TournamentFileUploadId', key: 'tournamentFileUploadId' },
  { label: 'EventName', key: 'eventName' },
  { label: 'StartDate', key: 'startDate' },
  { label: 'EndDate', key: 'endDate' },
  { label: 'SeasonWeek', key: 'seasonWeek' },
  { label: 'DivisionMale', key: 'divisionMale' },
  { label: 'NumberOfSchoolsInEvent', key: 'numberOfSchoolsInEvent' },
  { label: 'NoOfTeamsBelowReqGames', key: 'noOfTeamsBelowReqGames' }
]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/lowGameCountHeaders.js